// src/components/lab-post-builder.js

import React from "react"
import ContentWithAccentLetter from "../layouts/ContentWithAccentLetter"
import ImageBlock from "../layouts/ImageBlock"
import ContentBlockLab from "../layouts/ContentBlockLab"
import FullWidthImageLab from "../layouts/FullWidthImageLab"

const LabPostBuilder = ({ layoutData }) => {

  const layoutType = layoutData.fieldGroupName

  /**
   * Default component
   */
  const Default = () => <div>In AllLayouts the mapping of this component is missing: {layoutType}</div>

  /**
   * Mapping the fieldGroupName(s) to our components
   */
  const layouts = {
    LabPost_Labpostbuilder_LpPageBuilder_LpContentWithAccentLetter: ContentWithAccentLetter,
    LabPost_Labpostbuilder_LpPageBuilder_LpImageBlock: ImageBlock,
    LabPost_Labpostbuilder_LpPageBuilder_LpContentBlock: ContentBlockLab,
    LabPost_Labpostbuilder_LpPageBuilder_LpFullWidthImage: FullWidthImageLab,
    page_default: Default
  }

  /**
   * If layout type is not existing in our mapping, it shows our Default instead.
   */
  const ComponentTag = layouts[layoutType] ? layouts[layoutType] : layouts['page_default']

  return (
    <ComponentTag {...layoutData} />
  )
}

export default LabPostBuilder